const zh = {
  header: {
    tip1:
      "In order to prevent the system from accidentally closing the game in your virtual space, causing your game to be disconnected in unknown circumstances, you need to manually follow the following steps to complete the setting.",
  },
  content: {
    list1: {
      title:
        "When multi-process management state, add virtual master [lock] to keep the background running.",
    },
    list2: {
      title: "Open Mobile Manager and find App Manager.",
    },
    list3: {
      title:
        "Search for the virtual master, find the power saving policy, and set 'unlimited'.",
    },
  },
};

export default zh;
